// Actions
import { start, error, success, end } from 'REDUCERS/microphoneSlice';

// Utils
import microphoneCheck from 'CHECKS/microphone/microphoneCheck';
import { storeDeviceId } from 'UTILS/callbacks';

export default store => next => action => {
  switch (action.type) {
    case start.toString(): {
      next(action);
      const microphoneState = store.getState().checks.microphone;
      if (microphoneState.audioSourceList.length < 1) {
        store.dispatch(error({ type: 'no_audio_source' }));
        store.dispatch(end());
        return;
      } else {
        return microphoneCheck.start({
          deviceId: microphoneState.selectedAudioSourceId,
          logger: store.getState().app.isVerbose ? console : undefined,
          onError: (type, data) => store.dispatch(error({ type, data })),
          onSuccess: (type, data) => store.dispatch(success({ type, data })),
          onEnd: () => store.dispatch(end()),
        });
      }
    }
    case success.toString(): {
      next(action);
      if (store.getState().checks.microphone.selectedAudioSourceId) {
        storeDeviceId('audio', store.getState().checks.microphone.selectedAudioSourceId);
      }
      return;
    }
    default:
      return next(action);
  }
};
